import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Card, CardContent, CardHeader, Divider, CardActions, Button, Typography } from "@material-ui/core";
import { UserDataContext } from "../Contexts/UserDataContext";

const FinanceCard = () => {
  const history = useHistory();
  const { userData } = useContext(UserDataContext);

  return (
    <Card >
      <CardHeader title="Audit Information"></CardHeader>
      <Divider />
      <CardContent >
        <Typography>
          View finance / audit information about historical data.
        </Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Button variant="contained" color="primary" onClick={() => history.push(`/${userData.userName}/weekly-audit`)}>
          View Weekly Audit Data
        </Button>
        <Button variant="contained" color="primary" onClick={() => history.push(`/${userData.userName}/invoice-audit`)}>
          View Invoice Audit Data
        </Button>
      </CardActions>
    </Card>
  );
};

export default FinanceCard;
